import {AEditor} from "@/views/editor/service/editor";
import {INotifyMsTemplate, INotifyRole} from "@/views/editor/service/types";
import {IBusiness} from "@/views/editor/service/business";

export class Notify {
    // 消息: 依赖：对象
    readonly baseRoles: INotifyRole[] = [
        {
            name: '活动',
            is_virtual: true,
            events: {'pms.activity.preheating': '预热', 'pms.activity.progress': '开始', 'pms.activity.finish': '结束'},
            is_status_multiple: false,
            status: ['预热中', '进行中', '已结束']
        },
        {
            name: '微信顾客',
            is_virtual: false,
            events: {'pms.activity.wechat.customer.browse': '浏览'},
            is_status_multiple: true,
            status: ['已浏览', '已分享', '已报名', '已成交', '已核销']
        },
        {
            name: '手机号顾客',
            is_virtual: false,
            events: {'pms.activity.brand.branch.phone.number.customer.regular': '转老客'},
            is_status_multiple: false,
            status: ['新客', '老客']
        },
    ]

    readonly smsTemplates: { [key: string]: INotifyMsTemplate } = {
        'SMS_499120317': {
            id: 'SMS_499120317',
            name: '好友访问未下单',
            content: '您的分享活动${name}中，好友${nick_name}已关注但尚未参与，欢迎提醒他们点击查看详情 https://3tfx.cn/${code} 拒收请回复R'
        }
    }

    readonly vmsTemplates: { [key: string]: INotifyMsTemplate } = {
        'TTS_328575022': {
            id: 'TTS_328575022',
            name: '好友访问未下单',
            content: '你好，你关注的活动${name}已经开始，随后短信发给你，点击链接就能查看，留意消息，我这边就不打扰了'
        }
    }

    constructor(readonly editor: AEditor) {

    }

    roles(): INotifyRole[] {
        return [...this.baseRoles, ...this.editor.businesses.reduce((a: INotifyRole[], b: IBusiness): INotifyRole[] => {
            a.push(...b.roles())
            return a
        }, [])]
    }
}